export default function getQueryData(query: any = {}) {
  const { 'adhoc-token': adhocToken, spaceNodeId, spaceContactNodeId } = query;

  return { adhocToken, spaceNodeId, spaceContactNodeId };
}
